// Check what of paper is selected first to story and then use that in CurrentUrlSlug for deciding in what papers page it needs to be shown.
// Function to set accesstype to public if first selected section for the story is vaasa or epari.
// Function also sets paper name based on what section is selected first for a story. This can then be shown before timestamp.
// storysCurrentUrlSlug can be used to show story on correct paper based on what paper section is first selected in Bold.
export function generatePaperValues(storyObj) {
  var storysCurrentUrlSlug = "";
  var paperName = "";
  let accessType = storyObj.access;
  const inVaasa = storyObj.sections.findIndex(section => section["domain-slug"] === "vaasa");
  const inEpari = storyObj.sections.findIndex(section => section["domain-slug"] === "epari");
  const inIP = storyObj.sections.findIndex(section => section["domain-slug"] === "ilkka-pohjalainen");
  const indices = [inVaasa, inEpari, inIP].filter(index => index !== -1);
  const smallestIndex = Math.min(...indices);
  if (inEpari === smallestIndex && inEpari !== -1) {
    storysCurrentUrlSlug = "epari"
    accessType = "public"
    paperName = "Epari | "
  } else if (inVaasa === smallestIndex && inVaasa !== -1) {
    storysCurrentUrlSlug = "vaasalehti"
    accessType = "public"
    paperName = "Vaasa-lehti | "
  } else if (inIP === smallestIndex && inIP !== -1) {
    storysCurrentUrlSlug = "ilkka-pohjalainen"
    paperName = "Ilkka-Pohjalainen | "
  }

  return {
    storysCurrentUrlSlug: storysCurrentUrlSlug,
    accessType: accessType,
    paperName: paperName
  }
}
